import React, { useMemo } from 'react';
import Chart from './Chart';
import { STRINGS, formatCurrency } from '../utils/constants';
import { buildPieChartOptions, buildPieChartSeries } from '../utils/chartOptions';
import { EmptyState } from './StateView';

const PaymentDistribution = ({ data, isDarkMode }) => {
  const options = useMemo(() => buildPieChartOptions({ data, isDarkMode }), [data, isDarkMode]);
  const series = useMemo(() => buildPieChartSeries({ data }), [data]);

  const hasBreakdown = data.paymentBreakdown.length > 0;

  return (
    <div className="glass-card chart-card">
      <div className="card-title-bar">
        <h3>{STRINGS.paymentPieTitle}</h3>
      </div>

      {!hasBreakdown ? (
        <EmptyState />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Chart options={options} series={series} type="donut" height={240} />
          <div className="payment-details-list" style={{ width: '100%' }}>
            {data.paymentBreakdown.map((item) => (
              <div className="payment-method-row" key={item.id ?? item.name}>
                <div className="method-identity">
                  <div className="method-color-indicator" style={{ backgroundColor: item.color }} />
                  <span className="method-name">{item.name}</span>
                </div>
                <div className="method-stats">
                  <span className="method-percentage">{item.percentage}%</span>
                  <span className="method-amount">{formatCurrency(item.amount)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentDistribution;
